<template>
    <ui-checkbox-input
        :label="filter.text"
        :name="fKey"
        :value="filter.value"
        :tooltip="filter.tooltip"
        @change="$emit('set-filter', $event)"
    />
</template>

<script>
import filterMixin from './filter.mixin'

export default {
    mixins: [filterMixin]
}
</script>